import { render, staticRenderFns } from "./SwitcherAziende.vue?vue&type=template&id=2a0dd172&scoped=true"
import script from "./SwitcherAziende.vue?vue&type=script&lang=js"
export * from "./SwitcherAziende.vue?vue&type=script&lang=js"
import style0 from "./SwitcherAziende.vue?vue&type=style&index=0&id=2a0dd172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0dd172",
  null
  
)

export default component.exports